globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.blog = appVisitor.blog || {};

appVisitor.blog.likesController = (function() {
    function LikesController($html) {
        this.$html                = $html;
        this.$likesCounter        = this.$html.parents().eq(1).find('.likes-count');
    }

    LikesController.prototype = {
        init: function () {
          this.initEvents();
        },

        initEvents: function () {
          me = this;

            me.$html.on('click', '#like-identification-btn', function(e) {
                e.preventDefault();
                var $likePopup = me.$html.find('.like-identification-popup');
                $likePopup.fadeIn(200);
                $likePopup.find('.sb-vi-form-input').first().focus();

                return false;
            });

            me.$html.on('click', '.like-identification-popup .popup-close-button', function(e) {
                e.preventDefault();
                me.$html.find('.like-identification-popup').fadeOut(200);

                return false;
            });

            me.$html.on('submit', '.like-identification-popup form', function (e) {
                var $form = $(this);
                $.ajax({
                    type: "POST",
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    success: function (data) {
                        if (data.response == 1) {
                            me._saveLikeIdInCookies(data.id);

                            me.$html.find('.like-identification-popup').fadeOut(200, function () {
                                me.$html.find('#like-identification-btn').fadeOut(200, function () {
                                    me.$html.append($(data.views.articleUnlikeButton));
                                    me.$html.find('.blog-article-like').remove();
                                });
                            })

                            if (data.likes_count) {
                                me.$likesCounter.text(data.likes_count)
                            }

                        } else {
                            $.each(data.errors, function(key, value) {
                                var $error = $('<p class="error">' + value[0] + '</p>');
                                $error.prependTo(me.$form);
                            });
                        };
                    }
                });

                return false;
            });

            me.$html.on('click', '.like-identification-popup .cancel', function () {
                me.$html.find('.like-identification-popup').fadeOut(200);

                return false;
            });

          me.$html.on('submit', '.blog-article-like form', function (e) {
              var $form = $(this);
              $.ajax({
                  type: "POST",
                  url: $form.attr('action'),
                  data: $form.serialize(),
                  success: function (data) {
                      if (data.response == 1) {
                          me._saveLikeIdInCookies(data.id);

                          me.$html.find('.blog-article-like').fadeOut(200, function () {
                              me.$html.append($(data.views.articleUnlikeButton));

                              $(this).remove();
                          })

                          if (data.likes_count) {
                              me.$likesCounter.text(data.likes_count)
                          }

                      } else {
                          $.each(data.errors, function(key, value) {
                              var $error = $('<p class="error">' + value[0] + '</p>');
                              $error.prependTo(me.$form);
                          });
                      };
                  }
              });

              return false;
          });


          me.$html.on('submit', '.blog-article-unlike form', function (e) {
            var $form = $(this);

            $.ajax({
                type: "DELETE",
                url: $form.attr('action'),
                data: $form.serialize(),
                success: function (data) {
                    if (data.response == 1) {
                        me._deleteLikeIdInCookies(data.id);

                        me.$html.find('.blog-article-unlike').fadeOut(200, function () {
                            me.$html.append($(data.views.articleLikeButton));
                            $(this).remove();
                        })

                        if (data.likes_count) {
                            me.$likesCounter.text(data.likes_count)
                        }

                    } else {
                        $.each(data.errors, function(key, value) {
                            var $error = $('<p class="error">' + value[0] + '</p>');
                            $error.prependTo(me.$form);
                        });
                    };
                }
            });

            return false;
          });
        },

        _saveLikeIdInCookies: function (likeId) {
          if (likes = JSON.parse(utils.cookies.get('blog_article_likes'))) {
              likes.push(likeId)
              utils.cookies.create('blog_article_likes', likes);
          } else {
              utils.cookies.create('blog_article_likes', [likeId]);
          }
        },

        _deleteLikeIdInCookies: function (likeId) {
            if (likes = JSON.parse(utils.cookies.get('blog_article_likes'))) {
                var likeIndex = likes.indexOf(likeId);
                likes.splice(likeIndex - 1, 1);
                utils.cookies.create('blog_article_likes', likes);
            } else {
                utils.cookies.create('blog_article_likes', []);
            }
        }
    }

    return LikesController;
})();
